import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
} from "@angular/core";
import { EfficacyCriteria } from "../../store/students/state";
import { ArrowScrollForTablesComponent } from "../../dashboard-elements/arrow-scroll-for-tables/arrow-scroll-for-tables.component";
import { has } from "lodash";

@Component({
  selector: "student-comp-table",
  templateUrl: "./student-comp-table.component.html",
  styleUrls: ["./student-comp-table.component.scss"],
})
export class StudentCompTableComponent
  extends ArrowScrollForTablesComponent
  implements OnChanges {
  @ViewChild("scPaginator", { static: true }) scPaginator;

  @Input() panels;
  @Input() columns;
  @Input() districtMetrics;
  @Input() schoolOverall;
  @Input() school;
  @Input() studentState;
  @Input() sortsAndFilters;
  @Input() schools;
  @Input() groupCriteria: Array<EfficacyCriteria>;
  @Input() selectedAll: boolean;
  @Input() hasStudentSelected: boolean;
  @Input() groupStatusSort: string;
  @Input() groupStatusFilters: Array<string>;
  @Output() changePage = new EventEmitter();
  @Output() sortsFiltersSelected = new EventEmitter();
  @Output() studentSelected = new EventEmitter();
  @Output() selectAllChange = new EventEmitter();
  @Output() addGroupClicked = new EventEmitter();
  @Output() addStudentsToGroupClicked = new EventEmitter();
  @Output() removeStudentsFromGroupClicked = new EventEmitter();

  partialImagePath: string = "../../assets/images/";
  bodyRowHoveredIndex;
  fixedColRowHoveredIndex;
  headerIsStuck: boolean;
  isLongPage: boolean;
  pageSize: number = 10;
  protected tableType = "student";

  ngOnChanges(change) {
    if (
      has(change, "studentState.currentValue.students") &&
      has(change, "studentState.previousValue.students")
    ) {
      if (
        change.studentState.currentValue.students &&
        change.studentState.previousValue.students &&
        change.studentState.currentValue.students.length !=
          change.studentState.previousValue.students.length
      ) {
        this.isLongPage =
          !this.headerIsStuck &&
          this.studentState &&
          this.studentState.students &&
          this.studentState.students.length > 10;
      }
    }
  }

  bodyRowHovered(event) {
    this.bodyRowHoveredIndex = event;
    this.fixedColRowHoveredIndex = null;
  }

  fixedColRowHovered(event) {
    this.fixedColRowHoveredIndex = event;
    this.bodyRowHoveredIndex = null;
  }

  goToFirstPage() {
    this.scPaginator.firstPage();
  }

  headerStickinessChanged(isStuck) {
    this.headerIsStuck = isStuck;
    this.isLongPage =
      !this.headerIsStuck &&
      this.studentState &&
      this.studentState.students &&
      this.studentState.students.length > 10;
  }

  goToPage(index: number, size: number) {
    this.scPaginator.pageIndex = index;
    this.pageSize = size;
  }
}
